import { User, GraduationCap, Headphones, Users, MessageCircle, Radio } from "lucide-react";
import { useSite } from "@/contexts/SiteContext";

const ICON_FOR = {
  "Ședințe 1:1": User,
  "Cursuri": GraduationCap,
  "Audio-uri": Headphones,
  "Sesiuni de grup": Users,
  "Comunitate": MessageCircle,
  "Live-uri": Radio,
};

export default function ServiceBar() {
  const { sectionContent } = useSite();
  const cmsItems = sectionContent("service_bar")?.items;
  const fromCms = Array.isArray(cmsItems) && cmsItems.length > 0;
  const items = fromCms ? cmsItems : [
    "Ședințe 1:1", "Cursuri", "Audio-uri", "Sesiuni de grup", "Comunitate", "Live-uri",
  ];
  return (
    <section data-testid="service-bar" className="border-y" style={{ borderColor: "var(--ct-border)", background: "var(--ct-surface)" }}>
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-6 lg:py-8 overflow-x-auto no-scrollbar">
        <div className="flex items-center gap-8 lg:gap-12 min-w-max lg:min-w-0 lg:justify-between">
          {items.map((label, i) => {
            const Icon = ICON_FOR[label] || User;
            return (
              <div key={i} className="flex items-center gap-3 whitespace-nowrap" data-testid={`service-pill-${i}`}>
                <div className="w-9 h-9 rounded-full flex items-center justify-center" style={{ background: "var(--ct-emerald)", border: "1.5px solid var(--ct-gold)" }}>
                  <Icon size={16} style={{ color: "var(--ct-gold)" }} />
                </div>
                <span data-el="item_title" data-field={fromCms ? `items.${i}` : undefined} className="text-sm tracking-wide font-medium">{label}</span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
